// extracted by mini-css-extract-plugin
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var largeText = "NotFoundContainer-module--largeText--LQy3o";
export var notFoundContainer = "NotFoundContainer-module--notFoundContainer--YSKqh";
export var notFoundImage = "NotFoundContainer-module--notFoundImage--bN02H";
export var text = "NotFoundContainer-module--text--4hpyS";